export const ORDER_TYPES = [
  "booking",
  "ticket",
  "dateChange",
  "detailsChange",
  "openTicket",
  "void",
  "refund",
  "profile",
  "businessChange",
  "wallet",
  "withdrawal",
  "funding",
  "kyc",
  "other",
];

export const METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE"];

export const ENVIRONMENTS = ["development", "staging", "production"];

export function statusCodeTone(code) {
  if (code >= 500) return { bg: "#FEE2E2", color: "#B91C1C", border: "#FECACA" };
  if (code >= 400) return { bg: "#FFEDD5", color: "#C2410C", border: "#FED7AA" };
  return { bg: "#E0E7FF", color: "#3730A3", border: "#C7D2FE" };
}

export function environmentTone(env) {
  if (env === "production")
    return { bg: "#FEE2E2", color: "#B91C1C", label: "production" };
  if (env === "staging")
    return { bg: "#FEF3C7", color: "#B45309", label: "staging" };
  return { bg: "#DBEAFE", color: "#1D4ED8", label: "development" };
}

export function statusTone(status) {
  if (status === "resolved")
    return { bg: "#DCFCE7", color: "#15803D", label: "resolved" };
  return { bg: "#FEF3C7", color: "#B45309", label: "unresolved" };
}

export function orderLabel(order) {
  if (!order) return "—";
  return (
    order.orderId ||
    order.bookingId ||
    order.requestId ||
    order._id ||
    "—"
  );
}

export function truncate(value, max = 42) {
  if (!value) return "—";
  const text = String(value);
  return text.length > max ? `${text.slice(0, max)}…` : text;
}
